module.exports = __webpack_public_path__ + "static/media/udemy-web-developer.fd5f3a74.jpg";